import axios from "axios"
import redux from "../store"

export const getMedia = (url) => {
  if (url && !url.includes("/media")) {
    url = `/media/${url}`
  }
  url = `${process.env.REACT_APP_WEB_SERVICE}${url}`

  return url
}

const endpoint = `${process.env.REACT_APP_WEB_SERVICE}`

let instance = axios.create({
  baseURL: endpoint,
})

instance.interceptors.request.use(
  (config) => {
    if (config.method === "get") {
      if (config.url.indexOf("?") === -1) {
        config.url = `${config.url}?_=${Date.now()}`
      } else {
        config.url = `${config.url}&_=${Date.now()}`
      }
    }

    if (!config.headers["authorization"] && !config.headers["Authorization"]) {
      const token = redux.store.getState().auth.accessToken
      config.headers["Authorization"] = `Bearer ${token}`
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default instance



// WEBPACK FOOTER //
// ./src/api/common.js